/* @flow */

import {
  sideBarTabletWidth,
  sideBarLapWidth,
} from 'src/shared/app/base/component/template/style/template.style';
import { sidebarElevation } from 'src/shared/app/base/style/token/elevation';
import { tablet, lap } from '@e180/ui/lib/token/mediaQuery';

export default {
  root: {
    position: 'relative',
    zIndex: sidebarElevation,

    width: '100%',

    [tablet]: {
      width: sideBarTabletWidth,
      padding: [48, 0, 16],
    },
    [lap]: {
      width: sideBarLapWidth,
      padding: [40, 0, 20],
    },
  },
  children: {
    [tablet]: {
      marginTop: 48,
    },
    [lap]: {
      marginLeft: 36,
    },
  },
};
